import { supportedCountries } from '../constants/country'
import { COOKIE_KEYS, STORAGE_TTL } from '../constants/storage-keys'
import { setCookie } from './cookies'
import type { Country } from '../constants/country'

export const findCountryByCode = (countryCode: string): Country => {
  const normalizedCode = countryCode?.toLowerCase()
  return supportedCountries.find(({ cloudflareCountryCode }) => cloudflareCountryCode?.toLowerCase() === normalizedCode) ?? (supportedCountries[0] as Country)
}

export const getSelectCountryAndGeoIpText = (locale: string, currentCountry?: string) => {
  const defaultCountry = supportedCountries.find((item) => item.locale.toLowerCase() === 'en-us')
  const country = supportedCountries.find((item) => item.cloudflareCountryCode.toLowerCase() === currentCountry?.toLowerCase())
  const preferredLanguage = country?.alternateLanguages?.find((item) => item.locale?.toLowerCase() === locale?.toLowerCase())

  const getText = <T extends string>(key: T): string => {
    const source =
      preferredLanguage?.[key as keyof typeof preferredLanguage] ??
      country?.[key as keyof typeof country] ??
      defaultCountry?.[key as keyof typeof defaultCountry] ??
      ''

    return typeof source === 'string' ? source : ''
  }

  let countryText = country?.text
  if (preferredLanguage) {
    countryText += ` - ${preferredLanguage.text || ''}`
  }

  return {
    countryText,
    selectCountryText: getText('selectCountryText'),
    geoIpBarText: getText('geoIpBarText'),
    continueText: getText('continueText'),
    closeButtonText: getText('closeButtonText'),
    countryUrl: getText('url'),
    preferredLocale: preferredLanguage?.locale ?? country?.locale,
  }
}

export const setSelectedCountry = (val: string) => {
  setCookie(COOKIE_KEYS.SELECTED_COUNTRY, val, STORAGE_TTL.ONE_YEAR)
}

export const redirectToDefaultCountry = (dfCountry?: string) => {
  globalThis.location.href = dfCountry || 'https://www.vistaprint.com/'
}
